import {CSSProperties} from 'react';

import {css} from 'styled-components';

import {EStackDirection, TSpacingSize} from '../../types';

const column = css`
  display: flex;
  flex-direction: column;
`;

const row = css`
  display: flex;
  flex-direction: row;
`;

const flexAlign = (
  mainAxis: CSSProperties['justifyContent'],
  crossAxis?: CSSProperties['alignItems'],
  display?: 'flex' | 'inline-flex',
) => css`
  display: ${display ?? 'flex'};
  justify-content: ${mainAxis};
  align-items: ${crossAxis ?? mainAxis};
`;

type TStackDirection = keyof typeof EStackDirection;

type TStackProps = {
  direction?: TStackDirection;
  size?: TSpacingSize;
  align?: CSSProperties['alignItems'];
  justify?: CSSProperties['justifyContent'];
};

const stack = ({
  size = '0',
  direction = EStackDirection.COLUMN,
  align = 'start',
  justify = 'start',
}: TStackProps = {}) => css`
  ${({theme}) =>
    direction === EStackDirection.COLUMN
      ? css`
          ${column}
          ${flexAlign(align, justify)}
        gap: ${theme.spacing[`s${size}`]};
        `
      : css`
          ${row}
          ${flexAlign(justify, align)}
        gap: ${theme.spacing[`s${size}`]};
        `}
`;

export const layoutMixins = {stack, row, column, flexAlign} as const;
